/**
 * @file 契約者情報を管理するステート
 *
 * 契約者API（CONTRACT_INFO）から取得したお客さまの基本情報を保持する。
 * トップページの契約者情報セクションや、各種申込フォームの初期値として
 * アプリケーション全体で広く参照される中心的なステート。
 * セッションストレージに永続化し、画面遷移後も状態を維持する。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** 契約者情報の型 */
export type CustomerInfoStateType = {
  isp_cn_no: string; // お客さま番号
  last_name: string; // 姓
  first_name: string; // 名
  last_name_kana: string; // セイ
  first_name_kana: string; // メイ
  birthday: string; // 生年月日
  address_zip_code: string; // 郵便番号
  address_prefecture: string; // 都道府県
  address_city: string; // 市区町村
  address_town: string; // 町名/番地
  address_optional: string; // マンション/ビル名・部屋番号
  tel: string; // 連絡先電話番号
  tel_daytime: string; // 日中の連絡先電話番号
  mail: string; // メールアドレス
};

/**
 * 契約者情報を保持するRecoil atom。
 * 氏名・住所・連絡先等、マイページ全体で参照される基本情報。
 * セッションストレージに永続化される。
 */
/**
 * 契約者情報を保持するRecoil atom。
 * 氏名・住所・連絡先等、マイページ全体で参照される基本情報。
 * セッションストレージに永続化される。
 */
export const customerInfoState = atom<CustomerInfoStateType>({
  key: 'customerInfoState',
  default: {
    isp_cn_no: '',
    last_name: '',
    first_name: '',
    last_name_kana: '',
    first_name_kana: '',
    birthday: '',
    address_zip_code: '',
    address_prefecture: '',
    address_city: '',
    address_town: '',
    address_optional: '',
    tel: '',
    tel_daytime: '',
    mail: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default customerInfoState;
